import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Reveal } from '@/components/generals/reveal'

interface EyebrowProps {
    children: ReactNode
    className?: string
    align?: 'center' | 'left'
    animate?: boolean
}

/** Tiny, widely spaced uppercase label that opens every section. */
export const Eyebrow = ({ children, className, align = 'center', animate = true }: EyebrowProps) => {
    const classes = cn(
        'flex items-center gap-3 text-[11px] font-medium uppercase tracking-[0.34em] text-cream/55',
        align === 'center' ? 'justify-center' : 'justify-start',
        className
    )

    const content = (
        <>
            <span aria-hidden='true' className='size-1 rounded-full bg-citron shadow-[0_0_12px_2px_rgba(226,243,122,0.6)]' />
            <span>
                {children}
            </span>
        </>
    )

    if (!animate) {
        return (
            <p className={classes}>
                {content}
            </p>
        )
    }

    return (
        <Reveal as='p' className={classes} y={12}>
            {content}
        </Reveal>
    )
}
